// import { combineReducers } from 'redux'
import edmReducer from "./edmReducer";

// export default combineReducers({
//     edmReducer
// })
export default edmReducer;